<template>
  <div id="gfFrameLoader" v-if="isShowLoading" :class="{'show': isShowLoading}">
    <template>
      <div class="gp_loading_section">
        <div class="gfLoader-frame gfLoader-frame-new d-flex flex-column align-items-center">
          <div class="gfLoader-frame-new-logo">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M60.9414 0.020825L2.81123 18.1572C2.5764 18.2212 2.44831 18.4772 2.51236 18.7333L6.99541 33.4344C7.05945 33.6691 7.31562 33.8185 7.55045 33.7331L50.2035 20.4189C52.2315 19.7788 53.9607 18.3706 54.9427 16.4502C57.5898 11.3721 59.7887 6.0805 61.4751 0.596921C61.6032 0.234194 61.283 -0.0858595 60.9414 0.020825Z" fill="#FFBB1C" />
              <path d="M47.0012 25.4514L10.8807 36.7173C10.6885 36.7813 10.5604 36.9947 10.6245 37.2081L14.4244 49.6261C14.4884 49.8182 14.7019 49.9462 14.8941 49.8822L37.9284 42.6916C39.6576 42.1582 41.0879 40.942 41.9418 39.3418C44.1833 35.053 46.0406 30.5723 47.4496 25.9422C47.5563 25.6435 47.2788 25.3661 47.0012 25.4514Z" fill="#E8486C" />
              <path d="M31.2744 48.7893L18.2095 52.8647C18.0387 52.9074 17.9533 53.0994 17.996 53.2701L21.1982 63.7679C21.2409 63.9386 21.433 64.0452 21.6038 63.9812L23.6105 63.3625C25.0622 62.9144 26.279 61.8902 27.0048 60.5246C28.9048 56.8974 30.4632 53.1207 31.6587 49.1947C31.7654 48.9387 31.5306 48.704 31.2744 48.7893Z" fill="#476DF2" />
            </svg>
          </div>
          <div class="gp_loading_section-progress">
            <div class="gp_loading_section-progress-loading" :style="{'width': loadingCount + '%'}"></div>
          </div>
        </div>
        <div class="gp_loading_section-label">{{ isLoadingOnRendering ? $t("loadingFrame.label") : $t("page.loading.title") }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "LoadingFrame",
  props: {
    loadingDashboard: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    loadingCount: 0,
    isShowLoading: false,
  }),
  computed: {
    ...mapState("page", {
      loadingFrame: "loadingFrame",
      loadingFrameType: "loadingFrameType",
      defaultPageName: "defaultPageName"
    }),
    isLoadingOnCreateNewPage() {
      return this.loadingFrameType === "create_new_page"
    },
    isLoadingOnRendering() {
      return this.loadingFrameType === "rendering_loading"
    }
  },
  watch: {
    loadingFrame: {
      handler(isLoading) {
        if (isLoading) {
          this.showLoading();
        } else {
          this.hideLoading();
        }
      },
      deep: true
    }
  },
  methods: {
    hideLoading() {
      this.isShowLoading = false;
      return false;
    },
    showLoading() {
      this.loadingCount = 0;
      this.isShowLoading = true;
      this.loadingFrameType = false;
      const time = 1500;
      for (let i = 0; i < 1; i++) {
        const timer = i * time;
        this.setStatus(i, timer);
      }
      return false;
    },
    setStatus(i, timer) {
      setTimeout(() => {
        this.currentStep = i + 1;
        this.setLoadingProgressBar(1, 97, timer + 1500);
      }, timer);
      return false;
    },
    setLoadingProgressBar(start = 1, end = 97, duration = 1500) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const count = Math.floor(progress * (end - start) + start);
        this.loadingCount = isNaN(count) ? 0 : count;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
      return false;
    }
  }
});
</script>

<style lang="scss">
.gfLoader-frame-new {
  display: flex;
  justify-content: center;
  &.is-render {
    align-items: center;
    .gfLoader-frame-new-content {
      &__top {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
        &-step {
          display: none;
        }
      }
      &__bottom {
        display: none;
      }
    }
  }
  &-logo {
    margin-right: 16px;
    svg {
      path {
        &:nth-of-type(1) {
          animation: blink1 2s infinite;
        }
        &:nth-of-type(2) {
          animation: blink2 2s infinite;
        }
        &:nth-of-type(3) {
          animation: blink3 2s infinite;
        }
      }
    }
  }
  &-content {
    width: 100%;
    max-width: 324px;
    color: #fff;
    text-align: left;

    &__top {
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #E2E2E2;
      &-step {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #E2E2E2;
      }
      &-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        margin-top: 4px;
        color: #ffffff;
        .loading {
          margin-left: 4px;
        }
      }
    }

    &__bottom {
      &-desc {
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: #ffffff;
      }
    }
  }
}

@keyframes blink1 {
  0% {
    opacity: 0.25;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}

@keyframes blink2 {
  0% {
    opacity: 0.25;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}

@keyframes blink3 {
  0% {
    opacity: 0.25;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.25;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
#gfFrameLoader {
  position: fixed;
  top: 0;
  left: 0;
  background: #323232;
  z-index: 99999999991;
  transition: opacity 0.3s ease-in-out;
  width: 0px;
  height: 0px;
  overflow: hidden;
  opacity: 0;

  &.show {
    opacity: 1;
    display: block !important;
    width: 100%;
    height: 100%;
  }

  span.frame-loader {
    text-align: center;
    display: inline-block;
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 45%;
    width: 100%;
  }
}
.gp_loading_section {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .gfLoader-frame-new-logo {
    margin-right: 0;
  }
}
.gp_loading_section-progress {
  width: 184px;
  height: 4px;
  background: #494949;
  border-radius: 2px;
  margin-top: 24px;
  &-loading {
    background: #547AFF;
    border-radius: 2px;
    height: 4px;
  }
}
.gp_loading_section-label {
  position: fixed;
  bottom: 68px;
  left: 50%;
  transform: translateX(-50%);
  color: #AAAAAA;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}
</style>